import { useQuery, useMutation } from '@tanstack/react-query'
import { Identity, Me } from '../../shared/types'
import { get, post } from '../fetch'

export function useMeGet() {
	return useQuery({
		queryKey: ['api/me'],
		queryFn: () => get<Me>(`/api/0/me`),
	})
}

export function useMeListIdentities() {
	return useQuery({
		queryKey: ['api/me/identities'],
		queryFn: () => get<Identity[]>(`/api/0/me/identities`),
		select: data => {
			return Object.groupBy(data, identity => identity.provider)
		},
	})
}

export function useMeUpdate() {
	return useMutation({
		mutationFn: (data: FormData) => post(`/api/0/me`, data),
		meta: {
			invalidateQueries: [['api/me'], ['api/user']],
			notifications: {
				success: () => 'Změny uloženy',
			},
		},
	})
}
